import { render, staticRenderFns } from "./IntroductionMyPage.vue?vue&type=template&id=5f4bddb7&scoped=true&"
import script from "./IntroductionMyPage.vue?vue&type=script&lang=js&"
export * from "./IntroductionMyPage.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/renew2_mypage.css?vue&type=style&index=0&lang=css&"
import style1 from "./IntroductionMyPage.vue?vue&type=style&index=1&id=5f4bddb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4bddb7",
  null
  
)

export default component.exports